import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

/* Habilitar cuando el proyecto haya concluido. */
 import { enableProdMode } from '@angular/core';
  enableProdMode(); 

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
